import _toConsumableArray from "/var/lib/jenkins/workspace/vansterpartiet.se/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/var/lib/jenkins/workspace/vansterpartiet.se/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from "react";
export default function useSet() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a, b) {
    return a === b;
  };

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  return [values, {
    has: function has(value) {
      return values.findIndex(function (otherValue) {
        return isEqual(value, otherValue);
      }) !== -1;
    },
    add: function add(value) {
      setValues(function (values) {
        if (values.findIndex(function (otherValue) {
          return isEqual(value, otherValue);
        }) === -1) {
          return [].concat(_toConsumableArray(values), [value]);
        }

        return values;
      });
    },
    delete: function _delete(value) {
      setValues(function (values) {
        var index = values.findIndex(function (otherValue) {
          return isEqual(value, otherValue);
        });

        if (index !== -1) {
          return [].concat(_toConsumableArray(values.slice(0, index)), _toConsumableArray(values.slice(index + 1)));
        }

        return values;
      });
    },
    toggle: function toggle(value) {
      setValues(function (values) {
        var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var index = values.findIndex(function (otherValue) {
          return isEqual(value, otherValue);
        });

        if (index !== -1 && force !== true) {
          return [].concat(_toConsumableArray(values.slice(0, index)), _toConsumableArray(values.slice(index + 1)));
        }

        if (index === -1 && force !== false) {
          return [].concat(_toConsumableArray(values), [value]);
        }

        return values;
      });
    }
  }];
}